import { Rule } from "antd/lib/form";
import { NamePath } from "antd/lib/form/interface";

import { RVFormFloatingLabelWrap, RVTypeaheadSelect } from "@regal-voice/ui";
import { useEventSchemaForTypeahead } from "ServerData/EventSchema/Hooks/useEventSchemaForTypeahead/useEventSchemaForTypeahead";

import type { EventSchemaOptionEntry } from "ServerData/EventSchema/eventSchemaTypes";

export function PropertySelect({
    value,
    onChange,
    placeholder,
    label,
    eventSchema,
    dependencies,
    name,
    rules,
    hidden,
}: {
    value?: any;
    onChange?: (evt: any) => void;
    placeholder?: string;
    label: string;
    eventSchema: EventSchemaOptionEntry;
    dependencies?: NamePath[];
    name: NamePath;
    rules?: Rule[];
    hidden?: boolean;
}): JSX.Element {
    const propertyTypeahead = useEventSchemaForTypeahead({ eventSchema, onChange });

    return (
        <RVFormFloatingLabelWrap
            name={name}
            label={label}
            hidden={hidden}
            dependencies={dependencies}
            rules={rules}
            data-testid={`property-select-${name}`}
            noPadding
        >
            <RVTypeaheadSelect {...propertyTypeahead} value={value} onChange={onChange} placeholder={placeholder} />
        </RVFormFloatingLabelWrap>
    );
}
